<script lang="ts">
    export let small: boolean = false;
    export let nogap: boolean = false;
    export let max_cols = "3";
    export let gap = "2em";
</script>

<div class="row" class:small style:--max-cols={max_cols} style:--gap={nogap ? "0px" : gap}>
    <slot />
</div>

<style lang="scss">
    @import "./src/vars";

    .row {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }
    :global(.row > *) {
        width: calc(1 / var(--max-cols) * 100% - var(--gap)) !important;
        margin-bottom: var(--gap);
        @media (max-width: 1200px) {
            width: calc(1 / 2 * 100% - var(--gap)) !important;
        }
        @media (max-width: 800px) {
            width: 100% !important;
        }
    }
</style>
